<script setup lang="ts">
  import { MpText, MpCard, useMpScreen } from '@borg/ui';

  interface Education {
    id: string;
    institution: string;
    location: string;
    link: string;
    title: string;
  }

  const job = jobRepository.use();
  const { isMobile } = useMpScreen();
  const userStore = useUserStore();
  const BASE_URL = 'https://www.educentar.net/HR/Export/MpPrograms/18/';
  const query = {
    source_elem: 'edu_rec_details',
    adId: job.value?.id,
    adCategories: [job.value?.rootPosition?.id],
    userId: userStore.user?.id,
    qualification: 'VSHS',
    categories: [18],
  };

  const url = `${BASE_URL}?${objectToQueryString(query)}`;

  const { data: educations, error } = await useLazyFetch<Education[]>(url, {
    transform: (json) => JSON.parse(json),
    server: false,
  });

  const showWidget = computed(
    () => error.value === null && !!educations.value && educations.value.length > 0,
  );
</script>

<template>
  <MpCard
    v-if="showWidget"
    shadow
    border
    :p="isMobile ? 'md' : 'lg'"
    class="container no-print"
  >
    <LinksLocale
      to="https://www.educentar.net/"
      target="_blank"
      class="container__logo"
    >
      <Illustration image="educentar" />
    </LinksLocale>
    <ul class="education-list">
      <li
        v-for="education in educations"
        :key="education.id"
        class="education"
      >
        <a
          :href="`${education.link}?referrer=MP&position=ad-details`"
          target="_blank"
          class="education__link"
        >
          <MpText
            class="education__title"
            as="h6"
          >
            {{ education.title }}
          </MpText>
          <MpText class="education__place">
            {{ education.institution }}
          </MpText>
          <MpText
            no-margin
            class="education__location"
          >
            {{ education.location }}
          </MpText>
        </a>
      </li>
    </ul>
  </MpCard>
</template>

<style scoped lang="scss">
  .container {
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    justify-content: center;
    padding: 20px;
    color: var(--mp-color-text-05);

    &__logo {
      margin-bottom: var(--mp-space-40);
    }
  }

  .education-list {
    display: flex;
    flex-direction: column;
    width: 100%;
    gap: var(--mp-space-60);
    margin-bottom: 0;
  }

  .education {
    &__link {
      text-decoration: none;
      display: block;
      height: 100%;
      text-decoration: none;
    }

    &__title {
      color: #ec4a3e;
      font-weight: 700;
    }

    &__place {
      font-weight: 600;
      color: var(--mp-color-text-05);
    }

    &__location {
      display: block;
    }

    &:not(:last-child) {
      padding-bottom: var(--mp-space-55);
      border-bottom: 1px solid #dcdcdc;
      @include dark-mode {
        border-bottom: 1px solid var(--mp-color-grey-800);
      }
    }
  }
</style>
